import * as React from 'react'
import { Link } from 'widgets-for-react'

interface LinkBaseProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  isExternal?: boolean
  url: string
  children: React.ReactNode
}

export const InternalOrExternalLink = ({ children, isExternal, url, ...rest }: LinkBaseProps) =>
  isExternal ? (
    <a {...rest} target="_blank" rel="noopener noreferrer" href={url}>
      {children}
    </a>
  ) : (
    <Link {...rest} to={url}>
      {children}
    </Link>
  )
